// extracted by mini-css-extract-plugin
export var container = "_5i-0";
export var error = "_5i-9";
export var label = "_5i-5";
export var light = "_5i-6";
export var md = "_5i-3";
export var sm = "_5i-2";
export var thin = "_5i-8";
export var thinBold = "_5i-7";
export var vertical = "_5i-4";
export var xs = "_5i-1";